import styled, { css } from 'styled-components'
import { themeColor } from 'LibNeo'

export const AuthPassportKodWrapper = styled.div<{ hasError?: boolean }>`
	${({ hasError = false }) => css`
		.ant-select-search__field,
		.ant-select-search__field:hover {
			border-color: ${hasError ? themeColor('pink', 5) : themeColor('gray', 3)} !important;
		}
	`}
`
